import React from 'react';
import Typography from '@mui/material/Typography';
import { useCustomFetchDateParams } from '../../customHook/useCustomFetchDateParams';

const CardNoteComponent = ({ note, testid = 'card' }) => {
    
    return (
        <div className='note'>
            <Typography variant='h6' data-testid={`${testid}-noteText`} className='noteText'>{`${note}:`}</Typography>
            <Typography variant='subtitle1' data-testid={`${testid}-noteValue`} className='noteValue'>{`${useCustomFetchDateParams()?.startTime} - ${useCustomFetchDateParams()?.endTime}`}</Typography>
        </div>
    )
}

export default CardNoteComponent